module.exports = __webpack_public_path__ + "static/media/logo-exp.3b0a108e.svg";